export default class GoogleAnalytics {
  constructor($window) {
    'ngInject';

    Object.assign(this, { $window });
  }

  push(event) {
    if ('dataLayer' in this.$window) {
      let _event = event;
      if (typeof _event === 'string') {
        _event = { event };
      }

      this.$window.dataLayer.push(_event);
    }
  }
}
